import React, { useEffect, useState } from 'react';
import { LabelGroups } from './labelGroup';
import { LabelList } from './labelList';
import { RPCFactory } from '../../../../utils/RequestUtil';

const LabelManagePage = (props) => {
  const [groupList, setGroupList] = useState([]);
  const [groupId, setGroupId] = useState('');
  const [groupNum, setGroupNum] = useState(0);
  const [tagNum, setTagNum] = useState(0);

  useEffect(() => {
    RPCFactory.labelGroupManage.getGroups({ withChildren: true })
      .done((data) => {
        setGroupNum(data.size);
        setGroupList(data.entities);
      })
      .fail((ret, msg) => {});
  }, []);
  return (
    <div className="label-mangage">
      <div className="label-mangage-data">
        <span>标签分组数量：<span className='highlight'>{groupNum}</span>/100, 标签数量: <span className='highlight'>{tagNum}</span>/1000</span>
      </div>
      <div className="label-mangage-detail">
        <div className="label-groups">
          <LabelGroups
            groupList={groupList}
            tagGroupId={groupId}
            setGroupId={setGroupId}
            setGroupNum={setGroupNum}
            setTagNum={setTagNum}
            increaseGroupNum={() => setGroupNum(groupNum + 1)}
            decreaseGroupNum={() => setGroupNum(groupNum - 1)}
          />
        </div>
        <LabelList
          groupList={groupList}
          setGroupList={setGroupList}
          tagGroupId={groupId}
          increaseTagNum={() => setTagNum(tagNum + 1)}
          decreaseTagNum={() => setTagNum(tagNum - 1)}
        />
      </div>
    </div>
  );
};


export default LabelManagePage;
